import './styles/signin.css';
import './styles/3D.css';
import Alert from './alert.js';
import React, { useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getDatabase, ref, push, set } from "firebase/database"

function SignIn()
{

    const [txtEmail, setEmail] = useState("");
    const [txtPassword, setPassword] = useState("");
    const [alert_msg, setAM] = useState("");
    const [alert_type, setAT] = useState("");

    const signup = () => {
        firebase.auth().createUserWithEmailAndPassword(txtEmail, txtPassword)
        .then(() => {
        setEmail("");
        setPassword("");
        setAM("Sign up success");
        setAT("success");
        var new_user = {
            user_id: firebase.auth().currentUser.uid,
            email: txtEmail
        };
        const db = getDatabase();
        const db_ref = ref(db, "users");
        const new_ref = push(db_ref);
        set(new_ref, new_user);

        })
        .catch((error) => {
            setEmail("");
            setPassword("");
            setAM(error.message);
            setAT("error");
        });
    }

    const signin = () => {
        firebase.auth().signInWithEmailAndPassword(txtEmail, txtPassword)
        .then(() => {
        // Signed in
            setEmail("");
            setPassword("");
            setAM("Sign in success");
            setAT("success");
        })
        .catch((error) => {
            setEmail("");
            setPassword("");
            setAM(error.message);
            setAT("error");
        }); 
    }
    const google = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
        .then(() => {
        }).catch((error) => {
        // Handle Errors here.
            setAM(error.message);
            setAT("error");
        });
    }


    return(
        <div >
            <div>
                <div className="box"></div> 
            </div>
            
            <div className="container">
                <div id="custom-alert">
                    <Alert type={alert_type} message={alert_msg}/>
                </div>
                <div className="form-signin">
                        <h1 className="h3 mb-3 font-weight-normal">Please sign in/register</h1>
                        <label htmlFor="inputEmail" className="sr-only">Email address</label>
                        <input type="email" id="inputEmail" className="form-control" placeholder="Email address" required autoFocus value={txtEmail} onInput={e => setEmail(e.target.value)}/>
                        <label htmlFor="inputPassword" className="sr-only">Password</label>
                        <input type="password" id="inputPassword" className="form-control" placeholder="Password" required value={txtPassword} onInput={e => setPassword(e.target.value)}/>
                        <button className="btn btn-lg btn-primary btn-block" id="btnLogin" onClick={signin}>Sign in</button>
                        <button className="btn btn-lg btn-info btn-block" id="btngoogle" onClick={google}>Sign in with Google</button>
                        <button className="btn btn-lg btn-secondary btn-block" id="btnSignUp" onClick={signup}>New account</button>
                </div>
            </div>
        </div>
    );
}


export default SignIn;

